export default __webpack_public_path__ + "static/media/Mobile.ab28e914.gif";